import { styled } from '@material-ui/styles';
import { NavLink } from 'react-router-dom';
import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';

export const StyledLink = styled(NavLink)(({ theme }: { theme: ThemeOptions }) => ({
    color: theme.fontThemeColor1,
    textDecoration: 'none'
}));
